// This icon file is generated automatically.
var PDownCircleOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 14 14", "focusable": "false" }, "children": [{ "tag": "g", "attrs": { "fill-rule": "nonzero" }, "children": [{ "tag": "path", "attrs": { "d": "M9.78 5.33h-.73a.5.5 0 00-.4.2L7 7.81 5.36 5.53a.5.5 0 00-.4-.2h-.74c-.1 0-.16.11-.1.2L6.9 9.37c.05.07.15.07.2 0l2.78-3.84c.06-.09 0-.2-.1-.2z" } }, { "tag": "path", "attrs": { "d": "M7 0a7 7 0 100 14A7 7 0 007 0zm0 12.81A5.81 5.81 0 117 1.2 5.81 5.81 0 017 12.8z" } }] }] }, "name": "p-down-circle", "theme": "outlined" };
export default PDownCircleOutlined;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons-svg/es/asn/PDownCircleOutlined.js
// module id = 3345
// module chunks = 0